import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { useLayoutSize } from "../providers/LayoutProvider";
import { LayoutSize } from "../util/device";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
const Button = styled(PlayerControlButtonComponent) `
  span {
    white-space: nowrap;
  }
  // space between icon and label when both are showing
  svg + span {
    margin-left: 10px;
  }
`;
export const PlayerControlLabelButton = ({ label, autoHideLabel, ...props }) => {
    const layoutSize = useLayoutSize();
    // default auto hide to true
    if (autoHideLabel !== false &&
        [LayoutSize.SMALL, LayoutSize.SMALLEST].includes(layoutSize)) {
        label = "";
    }
    return _jsx(Button, { label: label, interactive: true, ...props });
};
